import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import Dashboard from './pages/Dashboard/Dashboard';
import Processos from './pages/Processos/Processos';
import DetalhesProcesso from './pages/DetalhesProcesso/DetalhesProcesso'; // Importação da nova página
import Configuracoes from './pages/Configuracoes/Configuracoes';
import TipoServicos from './pages/TipoServicos/TipoServicos';
import E2E from './pages/E2E/E2E';
import Gestores from './pages/Gestores/Gestores';
import Analistas from './pages/Analistas/Analistas';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/processos" element={<Processos />} />
          <Route path="/processos/:id" element={<DetalhesProcesso />} /> {/* Nova rota */}
          <Route path="/configuracoes" element={<Configuracoes />} />
          <Route path="/tiposervicos" element={<TipoServicos />} />
          <Route path="/e2e" element={<E2E />} />
          <Route path="/gestores" element={<Gestores />} />
          <Route path="/analistas" element={<Analistas />} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
}

export default App;
